import MediaQuery from 'src/DistributionPackages/Avaloq.NodeTypes/Resources/Private/JavaScript/Modules/MediaQuery'
function addContentTable(table) {
    // click title
    table.querySelectorAll('.js-content-table__title').forEach(dropDownFunc)

    function dropDownFunc(dropDown) {
        if (dropDown.classList.contains('js-content-table__title') === true) {
            dropDown.addEventListener('click', function (e) {
                e.preventDefault()

                if (this.nextElementSibling.classList.contains('dropdown-active') === true) {
                    this.parentElement.classList.remove('dropdown-open')
                    this.nextElementSibling.classList.remove('dropdown-active')
                    this.lastElementChild.classList.remove('is-active')
                } else {
                    closeDropdown()
                    this.parentElement.classList.add('dropdown-open')
                    this.nextElementSibling.classList.add('dropdown-active')
                    this.lastElementChild.classList.add('is-active')
                }
            })
        }
    }

    function closeDropdown() {
        document.querySelectorAll('.js-content-table').forEach(function (container) {
            container.classList.remove('dropdown-open')
        })
        document.querySelectorAll('.js-content-table__container').forEach(function (menu) {
            menu.classList.remove('dropdown-active')
        })
        document.querySelectorAll('.js-arrow-dropdown').forEach(function (dropdown) {
            dropdown.classList.remove('is-active')
        })
    }

    window.addEventListener('click', function (event) {
        if (event.target.classList.contains('content-table__button')) {
            var previouslyClicked = document.querySelector('.glide__bullet--active')
            if (previouslyClicked) {
                previouslyClicked.classList.remove('glide__bullet--active')
            }
            event.target.classList.toggle('glide__bullet--active')
        }
    })

    //Create table of contents
    const div = table.querySelector('.js-content-table__navigation')

    let quickLinkSelector = '.js-content-table__quick-link';
    if (!document.querySelectorAll(quickLinkSelector).length) {
        // fallback for old rule
        quickLinkSelector = '.text h2, .text h3, .text h4';
    }
    const headings = document.querySelectorAll(quickLinkSelector)

    if (headings.length > 0) {
        table.querySelector('.js-content-table__title-count').textContent = `(${headings.length})`
        table.style.display = 'block'

        for (let i = 0; i < headings.length; i++) {
            const navElement = document.createElement('h3')
            navElement.textContent = headings[i].textContent.replace(/(<([^>]+)>)/gi, '')
            navElement.addEventListener('click', (event) => onNavBtnClick(event, headings[i])) // Use arrow function here
            div.appendChild(navElement)
        }
    }

    // Menu scroll indicator
    const navigation = table.querySelector('.js-content-table__navigation')
    const headingsSideNavigation = navigation.querySelectorAll('h3')
    const headingsMainContent = headings;


    function onNavBtnClick(event, target) {
        target.scrollIntoView()
    }

    function initContentObserver() {
        const handleScroll = () => {
            closeDropdown()
            const threshold = window.innerHeight * 0.2

            headingsMainContent.forEach((heading, index) => {
                const rect = heading.getBoundingClientRect()
                const nextRect = headingsMainContent[index + 1]
                    ? headingsMainContent[index + 1].getBoundingClientRect()
                    : null
                const isVisible = rect.top <= threshold && (!nextRect || nextRect.top > threshold)
                const headingElement = headingsSideNavigation[index]

                if (isVisible) {
                    headingsSideNavigation.forEach((heading) => heading.classList.remove('active'))
                    headingElement.classList.add('active')
                }
            })
        }

        headingsSideNavigation.forEach((heading) => heading.classList.remove('active'))
        if (headingsSideNavigation.length > 0) {
            headingsSideNavigation[0].classList.add('active')
        }

        window.addEventListener('scroll', handleScroll)

        handleScroll()
    }

    function setContainerActive(target) {
        this.contentContainer.forEach((container) => {
            container.classList.remove('in-detail__content-container--active')
            container.classList.remove('in-detail__content-container--start')
        })
        target.classList.add('in-detail__content-container--active')
    }

    initContentObserver()
}

export function initContentTable() {
    const contentTables = document.querySelectorAll('.js-content-table')
    if (!contentTables) return
    contentTables.forEach((table) => {
        addContentTable(table)
    })
}
